<wf-icon class="offline-icon" iconName="wifi-off" />
<div class="offline-message">
  <h5>{{ 'OFFLINE_MESSAGE.Title' | translate }}</h5>
  <p>{{ 'OFFLINE_MESSAGE.Description' | translate }}</p>
</div>
